module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Paul Pham","slug":"blog/author/paul-pham","twitter":"","linkedIn":null,"website":"","biography":"","image":{"fields":{"description":"blog-author-paul-pham.jpg","file":{"url":"//images.ctfassets.net/k428n7s2pxlu/6XDxgF2BTGkIYuommOkcw0/dc3979b4f3c82c2f97906c92ca3c7c32/blog-author-paul-pham.jpg"}}}}},"pathContext":{"slug":"blog/author/paul-pham"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/blog-author-paul-pham.json
// module id = 1402
// module chunks = 199059229970273